import { Box, Chip, Collapse } from '@mui/material'
import startCase from 'lodash.startcase'

interface NotesFilterBarProps {
    visible: boolean
    templates: Array<{ id: string; templateType: string }>
    selectedFilter: string | null
    onFilterChange: (filter: string | null) => void
}

const NotesFilterBar = ({
    visible,
    templates,
    selectedFilter,
    onFilterChange,
}: NotesFilterBarProps) => {
    const sortedTemplates = [...templates].sort((a, b) =>
        a.templateType.localeCompare(b.templateType)
    )

    return (
        <Collapse in={visible}>
            <Box
                sx={{
                    display: 'flex',
                    gap: 0.5,
                    flexWrap: 'wrap',
                    px: 2,
                    pb: 1,
                }}
            >
                <Chip
                    label="All"
                    size="small"
                    color={selectedFilter === null ? 'primary' : 'default'}
                    variant={selectedFilter === null ? 'filled' : 'outlined'}
                    onClick={() => onFilterChange(null)}
                    sx={{ cursor: 'pointer' }}
                />
                {sortedTemplates.map((template) => (
                    <Chip
                        key={template.id}
                        label={startCase(template.templateType)}
                        size="small"
                        color={
                            selectedFilter === template.templateType
                                ? 'primary'
                                : 'default'
                        }
                        variant={
                            selectedFilter === template.templateType
                                ? 'filled'
                                : 'outlined'
                        }
                        onClick={() =>
                            onFilterChange(
                                selectedFilter === template.templateType
                                    ? null
                                    : template.templateType
                            )
                        }
                        sx={{ cursor: 'pointer' }}
                    />
                ))}
            </Box>
        </Collapse>
    )
}

export default NotesFilterBar
